import script from "./GstSteps.vue?vue&type=script&setup=true&lang=js"
export * from "./GstSteps.vue?vue&type=script&setup=true&lang=js"

import "./GstSteps.vue?vue&type=style&index=0&id=64e770a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64e770a6"]])

export default __exports__